import plusIcon from '../../../assets/images/icons/icon-plus.png';
import styles from './ProductFirstSelectTitle.module.scss';

interface ProductFirstSelectTitleProps {
  productImage: string;
  workImage?: string;
  title: string;
  backgroundColor?: string;
}

function ProductFirstSelectTitle({
  productImage,
  workImage,
  title,
  backgroundColor = 'white',
}: ProductFirstSelectTitleProps) {
  return (
    <div className={styles.componentStyle}>
      <div className={styles.imageContainer} style={{ backgroundColor: `var(--color-${backgroundColor})` }}>
        <img src={productImage} alt='Product' className={styles.productImage} />
      </div>
      <div className={styles.plusIconContainer}>
        <img src={plusIcon.src} alt='Plus' className={styles.plusIcon} />
      </div>
      {workImage && (
        <>
          <div className={styles.imageContainer} style={{ backgroundColor: `var(--color-${backgroundColor})` }}>
            <img src={workImage} alt='Work' className={styles.workImage} />
          </div>
          <div className={styles.plusIconContainer}>
            <img src={plusIcon.src} alt='Plus' className={styles.plusIcon} />
          </div>
        </>
      )}
      <div className={styles.titleContainer}>
        <div className={styles.title}>{title}</div>
      </div>
    </div>
  );
}

export default ProductFirstSelectTitle;
